'use client';

import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import type { Address } from 'viem';
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import Link from 'next/link';
import { memo } from 'react';
import { useTransactionContextV2 } from '@/contexts/Transaction';
import { getPortfolioUrl } from '@/helpers/routing';
import InfoCallout from '../InfoCallout';
import { useInKindRedemptionOutcome } from './useInKindRedemptionOutcome';
interface InKindRedemptionPortfolioAlertProps {
  /** The signer the redemption was submitted for — whose Portfolio holds the new position. */
  recipient: Address;
  vaultAddress: Address;
  /** The Market the user picked — see `InKindRedemptionReceiptContext.marketId`. */
  marketId: MarketId;
  /** The vault's underlying asset — what the redemption's legs are denominated in. */
  assetAddress: Address | undefined;
}

/**
 * Success-state callout (VRM-5347). The recap above it now shows the amounts
 * decoded from the receipt, so there is no worst-case caveat left to give —
 * this just points at the Portfolio where the received market lend position is
 * managed.
 */
const InKindRedemptionPortfolioAlert = t0 => {
  const $ = _c(12);
  const {
    recipient,
    vaultAddress,
    marketId,
    assetAddress
  } = t0;
  const {
    toggleDialog
  } = useDialogContext();
  const {
    reset
  } = useTransactionContextV2();
  let t1;
  if ($[0] !== assetAddress || $[1] !== marketId || $[2] !== vaultAddress) {
    t1 = {
      vaultAddress,
      marketId,
      assetAddress
    };
    $[0] = assetAddress;
    $[1] = marketId;
    $[2] = vaultAddress;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const outcome = useInKindRedemptionOutcome(t1);
  let t2;
  if ($[4] !== reset || $[5] !== toggleDialog) {
    t2 = () => {
      reset();
      toggleDialog(false);
    };
    $[4] = reset;
    $[5] = toggleDialog;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleNavigate = t2;
  if (outcome.kind !== "redeemed") {
    return null;
  }
  let t3;
  if ($[7] !== recipient) {
    t3 = getPortfolioUrl({
      userAddress: recipient
    });
    $[7] = recipient;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== handleNavigate || $[10] !== t3) {
    t4 = <InfoCallout data-testid="in-kind-redemption-portfolio-alert">Manage this position from{" "}<Link className="underline underline-offset-2" href={t3} onClick={handleNavigate}>your Portfolio</Link>.</InfoCallout>;
    $[9] = handleNavigate;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default memo(InKindRedemptionPortfolioAlert);